import React from 'react';
import Helmet from 'react-helmet';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Routes
import asyncRoute from './async-route';
const AsyncDashboard = asyncRoute(() => import('./routes/dashboard/index'));
const AsyncReports = asyncRoute(() => import('./routes/reports/index'));
const AsyncReportsManage = asyncRoute(() => import('./routes/reports/manage'));
const AsyncListing = asyncRoute(() => import('./routes/listing/index'));
const AsyncPaymentPlans = asyncRoute(() => import('./routes/payment-plans/index'));
const AsyncProfile = asyncRoute(() => import('./routes/profile/index'));
const AsyncMyTickets = asyncRoute(() => import('./routes/my-tickets/index'));
const AsyncYourOrder = asyncRoute(() => import('./routes/your-order/index'));
const AsyncYourTicket = asyncRoute(() => import('./routes/your-ticket/index'));
const AsyncInvoice = asyncRoute(() => import('./routes/invoice/index'));
const AsyncCreate = asyncRoute(() => import('./routes/create/index'));
const AsyncNotFound = asyncRoute(() => import('./routes/listing/not-found'));
const AsyncDiscountCodes = asyncRoute(() => import('./routes/codes'));
const AsyncMyEvents = asyncRoute(() => import('./routes/my-events'));
const AsyncBetaIntegrations = asyncRoute(() => import('./routes/integrations'));
const AsyncBalance = asyncRoute(() => import('./routes/balance'));
const AsyncWithdrawals = asyncRoute(() => import('./routes/withdrawals'));
const AsyncAutoWithdrawals = asyncRoute(() => import('./routes/auto-withdrawals'));

// Components
import DigitalData from './components/digital-data';

// Styles
import './app.css';

const Root = () => (
  <Router>
    <div className="App__container">
      <Helmet title="Universe Events" />
      <DigitalData />
      <Switch>
        <Route exact={true} path="/beta/create" component={AsyncCreate} />
        <Route exact={true} path="/beta/tickets" component={AsyncMyTickets} />
        <Route exact={true} path="/beta/payment-plans/:id" component={AsyncPaymentPlans} />
        <Route exact={true} path="/beta/order/:id" component={AsyncYourOrder} />
        <Route exact={true} path="/beta/ticket/:id" component={AsyncYourTicket} />
        <Route exact={true} path="/beta/invoice/:id" component={AsyncInvoice} />
        <Route exact={true} path="/events/:id" component={AsyncListing} />
        <Route exact={true} path="/dashboard/legacy" component={AsyncDashboard} />
        <Route exact={true} path="/dashboard/my-events" component={AsyncMyEvents} />
        <Route exact={true} path="/dashboard/tickets" component={AsyncMyTickets} />
        <Route exact={true} path="/dashboard/payment-plans/:id" component={AsyncPaymentPlans} />
        <Route exact={true} path="/dashboard/order/:id" component={AsyncYourOrder} />
        <Route exact={true} path="/dashboard/ticket/:id" component={AsyncYourTicket} />
        <Route exact={true} path="/dashboard/invoice/:id" component={AsyncInvoice} />
        <Route exact={true} path="/dashboard/discount-codes" component={AsyncDiscountCodes} />
        <Route exact={true} path="/users/:userPath" component={AsyncProfile} />
        <Route exact={true} path="/beta/users/:userPath" component={AsyncProfile} />
        <Route exact={true} path="/dashboard/reports" component={AsyncReports} />
        <Route exact={true} path="/dashboard/reports/create" component={AsyncReportsManage} />
        <Route exact={true} path="/dashboard/reports/edit/:report_id" component={AsyncReportsManage} />
        <Route exact={true} path="/beta/integrations" component={AsyncBetaIntegrations} />
        <Route exact={true} path="/dashboard/balance/:currency" component={AsyncBalance} />
        <Route exact={true} path="/withdrawals/new/:currency" component={AsyncWithdrawals} />
        <Route exact={true} path="/auto-withdrawals/manage/:currency" component={AsyncAutoWithdrawals} />
        <Route exact={true} path="/beta/dashboard/balance/:currency" component={AsyncBalance} />
        <Route exact={true} path="/beta/withdrawals/new/:currency" component={AsyncWithdrawals} />
        <Route exact={true} path="/beta/auto-withdrawals/manage/:currency" component={AsyncAutoWithdrawals} />
        <Route component={AsyncNotFound} />
      </Switch>
    </div>
  </Router>
);

export default Root;



// WEBPACK FOOTER //
// ./src/app.js